
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { namespace } from "vuex-class";
const profile = namespace("profile");

@Component({
  components: {

  },
  computed: {
    ...mapGetters(["profileData"]),
    ...mapState(['trainingVideos']),
    trainingVideo: function() {
      if (this.name){
        var name = this.name;
        var matches = this.trainingVideos.filter(function(v){
          return v.name == name;
        });

        if (matches && matches.length){
          return matches[0];
        }
      }
      return null;
    }
    
  },
})
export default class TrainingVideoLink extends Vue {
  @profile.State
  public trainingVideos: any;

  @Prop({ required: true }) readonly tooltipText!: string;

  @Prop({ required: true }) readonly displayText!: string;

  @Prop({ required: true }) readonly name!: string;

  openVideo(path: any) {
    window.open(path, '', 'addressbar=false,toolbar=false,width=900,height=600,left=200,top=200,resizable=yes,title=Learn How');
  }

}
